import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from "react-router-dom";
import popimg from "../../Common/Images/ImagesForAlert/popup_bg1.png";
import popbg from "../../Common/Images/ImagesForAlert/popup_bg2.png";
import popclose from "../../Common/Images/ImagesForAlert/popup_close_n.png";
import Loading from '../../Common/Loading';
import go_n from '../../Images/go_n.gif';
import go_o from '../../Images/go_o.gif';
import go_d from '../../Images/go_d.gif';
import close_n from '../../Images/close_n.gif';
import close_o from '../../Images/close_o.gif';
import close_d from '../../Images/close_d.gif';


const btnImages: Record<string, string> = {
    'go_n': go_n, 'go_o': go_o, 'go_d': go_d,
    'close_n': close_n, 'close_o': close_o, 'close_d': close_d
};

// --- Interfaces ---
interface SchoolOption {
    SchoolCode: string;
    Name: string;
}

interface UsageRecord {
    school_code: string;
    school_name: string;
    date: string;
    login: string;
    student: string;
    times: number;
    usage_mins: number;
    sessions: number;
    rate: number;
    amount: number;
}

// --- Helper: Image Button Component ---
const ImageButton: React.FC<{ name: string; onClick?: () => void; style?: React.CSSProperties }> = ({ name, onClick, style }) => {
    const [suffix, setSuffix] = useState('n');
    const imageKey = `${name}_${suffix}`;
    const imageSrc = btnImages[imageKey];

    return (
        <img
            src={imageSrc} alt={name}
            style={{ cursor: 'pointer', verticalAlign: 'middle', ...style }}
            onMouseEnter={() => setSuffix('o')}
            onMouseLeave={() => setSuffix('n')}
            onMouseDown={() => setSuffix('d')}
            onMouseUp={() => setSuffix('o')}
            onClick={onClick} draggable={false}
        />
    );
};

const EL_TutorCenterUsage: React.FC = () => {
   const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1; // 1-12

    let defaultMonth = currentMonth - 1;
    let defaultYear = currentYear;
    if (defaultMonth < 1) {
        defaultMonth = 12;
        defaultYear = currentYear - 1;
    }

    const generateYears = () => {
        let years = [];
        for (let y = currentYear; y >= 2008; y--) {
            years.push(y);
        }
        return years;
    };

    const navigate = useNavigate();

    const [schools, setSchools] = useState<SchoolOption[]>([]);
    const [selectedSchoolCode, setSelectedSchoolCode] = useState('--Select--');
    const [schoolNameLabel, setSchoolNameLabel] = useState('');

    const [month, setMonth] = useState(defaultMonth.toString().padStart(2, '0'));
    const [year, setYear] = useState(defaultYear.toString());
    const yearsList = useMemo(() => generateYears(), [currentYear]);

    const [data, setData] = useState<UsageRecord[]>([]);
    const [loading, setLoading] = useState(false);

    document.body.style.backgroundColor = "azure";

useEffect(() => {
    document.body.style.margin = '0px';

    const fetchInitialData = async () => {
        setLoading(true);
        try {
            const res = await fetch(`${API_BASE_URL}api/get_tutor_center_init`);
            const json = await res.json();
            if (json.schools) setSchools(json.schools);
        } catch (err) {
            console.error("Init Error", err);
        } finally {
            setLoading(false);
        }
    };

    fetchInitialData();
}, []);

    useEffect(() => {
        if (selectedSchoolCode === '--Select--') {
            setSchoolNameLabel('');
        } else {
            const school = schools.find(s => s.SchoolCode === selectedSchoolCode);
            if (school) setSchoolNameLabel(school.SchoolCode);
        }
    }, [selectedSchoolCode, schools]);

    // --- Handlers ---
    const handleGo = async () => {
        if (selectedSchoolCode === '--Select--') {
            alert('Please Select School Code');
            return;
        }
        if (month === '--Select--') {
            alert('Please Select a Month');
            return;
        }

        setLoading(true);
        try {
            const res = await fetch(`${API_BASE_URL}api/get_tutor_center_usage`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    school_code: selectedSchoolCode,
                    month: month,
                    year: year
                })
            });
            const json = await res.json();
            if (json.error) alert(json.error);
            else setData(json.results || []);
        } catch (err) {
            alert("Error fetching report data");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        navigate("/SysAdmin")
    };

    const grandTotalAmount = data.reduce((acc, row) => acc + row.amount, 0);

    const styles = {
        container: { fontFamily: 'Arial, Trebuchet MS', fontSize: '10pt', margin: '0 auto', width: '100%' },
        headerTable: { width: '100%', margin: '0 auto', fontFamily: 'Arial', padding: '5px' },
        titleRow: { fontWeight: 'bold', padding: '8px', textDecoration: 'underline' as const, textAlign: 'center' as const },
        filterRow: { padding: '5px' },
        labelDarkBlue: { color: 'darkblue', textAlign: 'right' as const },
        valueDarkBlue: { color: 'darkblue', textAlign: 'left' as const },
        select: { fontFamily: 'Trebuchet MS', fontSize: '10pt', marginLeft: '5px', marginRight: '15px' },

        gridWrapper: { padding: '8px', textAlign: 'center' as const, overflowX: 'auto' as const, width: '100%', border: 'solid 1px #A0A0A0', borderTopStyle: 'none' as const },
        table: { width: '100%', borderCollapse: 'collapse' as const, fontFamily: 'Trebuchet MS', fontSize: '8pt', color: 'black' },
        th: { backgroundColor: '#2f6089', color: 'White', fontWeight: 'normal', padding: '5px', textAlign: 'left' as const, borderBottom: '1px solid #ccc' },
        td: { padding: '5px', textAlign: 'left' as const, borderBottom: '1px solid #eee' },
        footer: { backgroundColor: '#EAF0EA', fontWeight: 'bold', padding: '5px', borderTop: '2px solid #ccc' }
    };

    return (
        <div style={styles.container}>
            {loading && <Loading />}
            <div
                style={{
                    backgroundImage: `url(${popimg}), url(${popbg})`,
                    backgroundRepeat: "no-repeat, no-repeat",
                    backgroundPosition: "left center, right center",
                    backgroundSize: "30% 100%, 70% 100%",
                    height: "16px",
                    color: "white",
                    padding: "7px 0px",
                    fontWeight: "bold",
                    fontSize: "12pt",
                    fontFamily: "arial",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                }}
            >
                <span style={{ marginLeft: "10px" }}>
                    Tutor Center Usage
                </span>
                <img
                    src={popclose}
                    alt="close"
                    height="30px"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/SysAdmin")}
                />
            </div>
            <div id="divFirst">
                <table style={styles.headerTable}>
                    <tbody>
                        <tr>
                            <td colSpan={6} style={styles.titleRow}>TUTOR CENTER USAGE</td>
                        </tr>
                        <tr>
                            <td style={styles.filterRow}>
                                SchoolCode :
                                <select style={styles.select} value={selectedSchoolCode} onChange={(e) => setSelectedSchoolCode(e.target.value)}>
                                    <option value="--Select--">-Select-</option>
                                    {schools.map(s => <option key={s.SchoolCode} value={s.SchoolCode}>{s.Name}</option>)}
                                </select>
                            </td>
                            <td style={styles.labelDarkBlue}>School Name:</td>
                            <td style={styles.valueDarkBlue}>
                                <span>{schoolNameLabel}</span>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                &nbsp;&nbsp;&nbsp;&nbsp; Month:
                                <select style={styles.select} value={month} onChange={(e) => setMonth(e.target.value)}>
                                    <option value="--Select--">-Select-</option>
                                    <option value="01">Jan</option>
                                    <option value="02">Feb</option>
                                    <option value="03">Mar</option>
                                    <option value="04">Apr</option>
                                    <option value="05">May</option>
                                    <option value="06">Jun</option>
                                    <option value="07">Jul</option>
                                    <option value="08">Aug</option>
                                    <option value="09">Sep</option>
                                    <option value="10">Oct</option>
                                    <option value="11">Nov</option>
                                    <option value="12">Dec</option>
                                </select>
                                &nbsp;&nbsp;&nbsp;&nbsp;Year:
                                <select style={styles.select} value={year} onChange={(e) => setYear(e.target.value)}>
                                    {yearsList.map(y => <option key={y} value={y}>{y}</option>)}
                                </select>
                            </td>
                            <td style={{ textAlign: 'left' }}>
                                <ImageButton name="go" onClick={handleGo} />
                            </td>
                            <td style={{ textAlign: 'right' }}>
                                <ImageButton name="close" onClick={handleClose} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* Dynamic Grid Results */}
            <div id="tblTutorCenterUsage" style={styles.gridWrapper}>
                {data.length > 0 ? (
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.th}>SchoolCode</th>
                                <th style={styles.th}>SchoolName</th>
                                <th style={styles.th}>Date</th>
                                <th style={styles.th}>Login</th>
                                <th style={styles.th}>Student</th>
                                <th style={styles.th}>Times</th>
                                <th style={styles.th}>Usage(Mts)</th>
                                <th style={styles.th}>Sessions</th>
                                <th style={styles.th}>Rate</th>
                                <th style={styles.th}>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((row, idx) => (
                                <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? 'white' : '#EFF3FB', verticalAlign: 'text-top' }}>
                                    <td style={styles.td}>{row.school_code}</td>
                                    <td style={styles.td}>{row.school_name}</td>
                                    <td style={styles.td}>{row.date}</td>
                                    <td style={styles.td}>{row.login}</td>
                                    <td style={styles.td}>{row.student}</td>
                                    <td style={styles.td}>{row.times}</td>
                                    <td style={styles.td}>{row.usage_mins}</td>
                                    <td style={styles.td}>{row.sessions}</td>
                                    <td style={styles.td}>{row.rate}</td>
                                    <td style={styles.td}>{row.amount}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={9} style={{ ...styles.footer, textAlign: 'right' }}>Grand Total:</td>
                                <td style={styles.footer}>{grandTotalAmount.toFixed(2)}</td>
                            </tr>
                        </tfoot>
                    </table>
                ) : (
                    <div style={{ marginTop: '20px', color: '#666' }}>No data available for the selected period.</div>
                )}
            </div>
        </div>
    );
};

export default EL_TutorCenterUsage;